export interface CardImageProps {
  webpUrl?: string;
  originalUrl: string;
  jpgUrl?: string;
  alt: string;
  title: string;
  classes?: string;
}

export interface cardImageWithSourcesProps {
  fallbackImage: imageSourceProps;
  sources: imageSourceProps[];
  imageAltText: string;
  imageTitle: string;
}

export interface imageSourceProps {
  src: string;
  media?: string;
  type: string;
  width: number;
  height: number;
}

export interface ImageContainer extends CropRatio {
  children?: JSX.Element[] | JSX.Element | null;
  classes?: string;
}

export interface CropRatio {
  cropRatio:
    | 'w45h28'
    | 'w31h40'
    | 'w427h400'
    | 'w33h20'
    | 'w17h5'
    | 'w7h5'
    | 'flag';
}

export interface KeyValuePair {
  key: string;
  value: string;
}

export enum ScreenSize {
  Xs = 0,
  Sm = 576,
  Md = 768,
  Lg = 992,
  Xl = 1200,
  Xxl = 1400,
}

// Card Props
export interface PricingData {
  price: number;
  originalPrice: number;
  currency: string;
  customText: string;
}

export interface PillProps {
  class?: string;
  text?: string;
  icon?: string;
  isVisible?: boolean;
}

export interface ReviewSummary {
  avg: number;
  description: string;
}
